import React, { type HTMLAttributes, useCallback } from 'react';

import * as styled from './Anchor.styled';
import { type Props } from './Anchor.types';

const noop = () => null;

/**
 * @deprecated Use `TeamsAnchor` from `@atlaskit/teams-app-internal-navigation/teams-anchor`. Delete this component when the `ptc-react-router-dom-links-migration` feature gate is cleaned up.
 * TODO: Remove emotion/styled and emotion/react when this component is deleted.
 */
export default function Anchor(
	props: Props & HTMLAttributes<HTMLAnchorElement>,
): React.JSX.Element {
	const { onMouseDown = noop, to } = props;

	const handleInternalMouseDown = useCallback(
		(event: React.MouseEvent<HTMLAnchorElement>) => {
			event.preventDefault();
			onMouseDown(event);
		},
		[onMouseDown],
	);

	const renderLink = () => {
		// should not move this to outside renderLink func because of spread operator
		const { children, href, to, appearance = 'default', target, ...linkProps } = props;

		return (
			<styled.StyledLink
				{...linkProps}
				onMouseDown={handleInternalMouseDown}
				to={to!}
				appearance={appearance}
			>
				{children}
			</styled.StyledLink>
		);
	};

	const renderAnchor = () => {
		// should not move this to outside renderAnchor func because of spread operator
		const { children, to, appearance = 'default', ...anchorProps } = props;

		return (
			<styled.NormalStyledAnchor
				rel="noopener noreferrer"
				{...anchorProps}
				appearance={appearance}
				onMouseDown={handleInternalMouseDown}
			>
				{children}
			</styled.NormalStyledAnchor>
		);
	};

	if (to) {
		return renderLink();
	}

	return renderAnchor();
}
